// src/pages/Login.jsx
import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import AuthShell, { IconEye, IconArrow } from '../components/auth/AuthShell';

export default function Login() {
    const { login } = useContext(AuthContext);
    const [identifier, setIdentifier] = useState('');
    const [password, setPassword] = useState('');
    const [showPass, setShowPass] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await api.post('/auth/login', { identifier: identifier.trim(), password });
            login(res.data.token);
        } catch (err) {
            toast.error(err.response?.data?.error || 'Credenciales inválidas', { autoClose: 3000 });
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell>
            <h1 className="auth-title">Iniciar sesión</h1>
            <p className="auth-subtitle">Ingresa tus credenciales para continuar</p>

            <form onSubmit={handleSubmit}>
                <div className="auth-field">
                    <div className="auth-field-header">
                        <label className="auth-label" htmlFor="lg-identifier">Correo o usuario</label>
                    </div>
                    <input
                        id="lg-identifier"
                        type="text"
                        className="auth-input"
                        value={identifier}
                        onChange={e => setIdentifier(e.target.value)}
                        placeholder="tu@correo.com o usuario"
                        required autoFocus autoComplete="username"
                    />
                </div>

                <div className="auth-field">
                    <div className="auth-field-header">
                        <label className="auth-label" htmlFor="lg-password">Contraseña</label>
                        <Link to="/forgot-password" className="auth-link">
                            ¿Olvidaste tu contraseña?
                        </Link>
                    </div>
                    <div className="auth-input-wrap">
                        <input
                            id="lg-password"
                            type={showPass ? 'text' : 'password'}
                            className="auth-input has-toggle"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            placeholder="Coloca aquí tu contraseña"
                            required autoComplete="current-password"
                        />
                        <button
                            type="button"
                            className="auth-toggle"
                            onClick={() => setShowPass(v => !v)}
                            tabIndex={-1}
                            aria-label={showPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                        >
                            <IconEye off={showPass} />
                        </button>
                    </div>
                </div>

                <button type="submit" className="auth-submit" disabled={loading}>
                    {loading ? <Spinner size="sm" animation="border" /> : <>Iniciar sesión <IconArrow /></>}
                </button>
            </form>

            <div className="auth-footer-link">
                Si necesitas ayuda, contacta a tu administrador de TI:
                <div style={{ marginTop: 10, display: 'flex', gap: 18, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <a
                        className="auth-link"
                        href="mailto:proyectosti@caprepa.com?subject=Ayuda%20con%20mi%20acceso%20al%20Desk"
                        style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}
                    >
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3.5 7l8.5 6 8.5-6" />
                        </svg>
                        Correo
                    </a>
                    <a
                        className="auth-link"
                        href="https://wa.me/16624837162?text=Hola%2C%20necesito%20ayuda%20con%20mi%20acceso%20al%20Desk"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}
                    >
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M4 20l1.4-4A8 8 0 1 1 8 18.6z" /><path d="M9 9.6c0 3 2.4 5.4 5.4 5.4.6 0 1-.7.6-1.2l-.9-1a.7.7 0 0 0-.8-.1l-.6.3a4 4 0 0 1-1.9-1.9l.3-.6a.7.7 0 0 0-.1-.8l-1-.9c-.5-.4-1.2 0-1.2.6z" />
                        </svg>
                        WhatsApp
                    </a>
                </div>
            </div>
        </AuthShell>
    );
}
